
<section class="page-container d-flex flex-column align-items-center justify-content-center">
<h2 class="mt-5 mb-5">
  A keresett termék/kategória nem található.
</h2>

  <p><a href="/">Kezdőlap</a></p>
</section>

